import _ from 'lodash'
import PropTypes from 'prop-types'
import React, { Component } from 'react'
import { Collapse } from 'react-bootstrap'
import { connect } from 'react-redux'
import { Link } from 'react-router-dom'
import BurgerIcon from '../../components/icons/BurgerIcon'
import Sidenav from '../../vendor/libs/sidenav'
import layoutHelpers from './helpers'

class LayoutSidenav extends Component {
    state = {
        stdImage:
            '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',
        reportMenuToggle: this.props.user?.activeCollapseMenu ? true : false,
        menus: [],
        eventKeyCollapse: this.props.user?.activeCollapseMenu,
        collapseIndex: [],
    }

    layoutSidenavClasses() {
        let bg = this.props.sidenavBg

        // console.log("layoutSidenavBG", bg)

        if (this.props.orientation === 'horizontal' && (bg.indexOf(' sidenav-dark') !== -1 || bg.indexOf(' sidenav-light') !== -1)) {
            bg = bg.replace(' sidenav-dark', '').replace(' sidenav-light', '').replace('-darker', '').replace('-dark', '')
        }

        return (
            `bg-${bg} ` +
            (this.props.orientation !== 'horizontal' ? 'layout-sidenav greentab' : 'layout-sidenav-horizontal container-p-x flex-grow-0 greentab') +
            ' menu-scroll'
        )
    }

    toggleSidenav(e) {
        e.preventDefault()
        layoutHelpers.toggleCollapsed()
    }

    isMenuActive(url) {
        return this.props.location.pathname.indexOf(url) === 0
    }

    isSubmenuActive(menuObj) {
        if (menuObj.subMenus && menuObj.subMenus.length > 0) {
            return menuObj.subMenus.filter(item => {
                return this.props.location.pathname.indexOf(item.menuUrl) === 0
            }).length > 0
                ? true
                : false
        } else {
            return false
        }
    }

    isMenuOpen(url) {
        return this.props.location.pathname.indexOf(url) === 0 && this.props.orientation !== 'horizontal'
    }

    componentDidMount() {
        console.log(this.props.user)
        // this.loadStdImage();
        this.generateMenu()

        console.log('compDidMount: reportMenuToggle', this.state.reportMenuToggle)
        console.log('compDidMount: eventKeyCollapse', this.state.eventKeyCollapse)
    }

    componentDidUpdate() {
    }

    generateMenu = () => {
        const {roleMenus} = this.props.user
        //const moduleFilter = ['ASM','AVS','EVA','FIN','GRD','TRC','TRF','RAP','REG','MAN','CUR'];
        //const menusFilter = roleMenus.filter(item => moduleFilter.includes(item.menuModule))
        const menuL1 = roleMenus.filter(item => item.menuType == 2)
        const menuL2 = roleMenus.filter(item => item.menuType == 3)
        const menuL3 = roleMenus.filter(item => item.menuType == 4)

        const menul2withl3 = menuL2.map(iteml2 => {
            const childMenu = menuL3.filter(iteml3 => iteml3.parentMenuId == iteml2.menuId)
            return {...iteml2, subMenusL3: childMenu}
        })

        const menul1withl2 = menuL1.map(iteml1 => {
            const childMenu = menul2withl3.filter(iteml2 => iteml2.parentMenuId == iteml1.menuId)
            return {...iteml1, subMenusL2: childMenu}
        })

        this.setState(
            {
                roleMenus: [...menul1withl2],
                menuHeader: roleMenus.filter(item => item.menuType == 1),
            },
            () => {
                this.state.menuHeader.map((i, k) => {
                    if (this.isMenuActive(i.menuUrl) || this.isSubmenuActive(i)) {
                        let newCollapseIndex = this.state.collapseIndex.slice()
                        newCollapseIndex.push(k)
                        this.setState({
                            collapseIndex: newCollapseIndex,
                        })
                    }
                })
            },
        )
    }

    //* reserved function
    // genMenu = () => {
    //   const { roleMenus } = this.props.user

    //   let sideMenu = _.chain(roleMenus).groupBy("parentMenuId").map((value, key) => {
    //     let someValue = value.filter((v, i) => v.parentMenuId === key)
    //     console.log("some value", someValue)
    //     console.log("value", value)
    //     console.log("key", key)
    //     return { parentMenuId: key, subMenus: value }
    //   }).value()

    //   console.log("menu result:", sideMenu)

    //   this.setState({ menus: sideMenu })
    // }



    toggleMenu = index => {
        console.log('index toggle', index)

        if (this.state.collapseIndex.includes(index)) {
            let newCollapseIndex = this.state.collapseIndex.filter(item => item != index)
            this.setState({
                collapseIndex: newCollapseIndex,
            })
        } else {
            let newCollapseIndex = this.state.collapseIndex.slice()
            newCollapseIndex.push(index)
            this.setState({
                collapseIndex: newCollapseIndex,
            })
        }
    }

    isShow = (index, menuUrl) => {
        console.log('isShow', index, this.state.collapseIndex, menuUrl, this.state.firstLoad)
        if (this.state.collapseIndex.includes(index)) {
            console.log('here 1 true', index, menuUrl)
            return true
        } else {
            console.log('here 3 false')
            return false
        }
    }

    getToggleClass = index => {
        const toggleStatus = this.state.collapseIndex.includes(index)
        const toggleClass = toggleStatus
            ? 'd-block ion ion-ios-arrow-down collapse-animation '
            : 'd-block ion ion-ios-arrow-down collapse-animation isCollapsing'
        return toggleClass
    }

    buildMenusWithSource = () => {
        if (!this.state.menuHeader) {
            return <></>
        }

        return this.state.menuHeader.map((i, k) => (
            <div
                key={k}
                style={{width: '100%'}}
            >
                <Sidenav.Header
                    className="xlarg font-weight-semibold"
                    style={{
                        display: 'flex',
                        flexDirection: 'row',
                        justifyContent: 'space-between',
                        cursor: 'pointer',
                        color: this.state.collapseIndex.includes(k) ? "white" : "#828487"
                    }}
                    onClick={() => this.toggleMenu(k)}
                >
                    {i.menuNameTh}{' '}
                    <span className="cursor toggle-button nobg nopd">
            <i className={this.getToggleClass(k)}></i>
          </span>
                </Sidenav.Header>
                <Collapse
                    in={this.isShow(k, i.menuUrl, this.state.firstLoad)}
                    style={{width: '100%'}}
                >
                    <div>
                        {this.state?.roleMenus
                            .filter(item => item.menuModule == i.menuModule)
                            .map(
                                (
                                    item,
                                    index, //item = lv นอกสุด (menutype = 2)
                                ) => (
                                    <React.Fragment key={index}>
                                        {item.subMenusL2 && item.subMenusL2.length > 0 ? (
                                            <Sidenav.Menu
                                                icon="menuIcon typeConfigIcon"
                                                linkText={item.menuNameTh}
                                                badgeVariant="primary"
                                                active={this.isMenuActive(item.menuUrl) || this.isSubmenuActive(item)}
                                                open={this.isMenuOpen(item.menuUrl) || this.isSubmenuActive(item)}
                                            >
                                                <>
                                                    {item.subMenusL2.map((subMenu, subIndex) => {
                                                        //item.subMenu = lv 2 (menutype = 3)
                                                        //เช็คว่าตัวนี้มีลูกไหม ถ้ามีลูก ให้ใช้คอมโพเน้น ไซด์นาบเมนู ถ้าไม่มี ให้แสดงเป็น ไซด์นาบลิ๊งค์
                                                        let result
                                                        if (subMenu.subMenusL3 && subMenu.subMenusL3.length > 0) {
                                                            result = (
                                                                <Sidenav.Menu
                                                                    key={subIndex}
                                                                    //icon="menuIcon typeConfigIcon"
                                                                    linkText={subMenu.menuNameTh}
                                                                    badgeVariant="primary"
                                                                    active={this.isMenuActive(subMenu.menuUrl)}
                                                                    open={this.isMenuOpen(subMenu.menuUrl)}
                                                                >
                                                                    {subMenu.subMenusL3.map((il3, ik3) => (
                                                                        <Sidenav.RouterLink
                                                                            key={ik3}
                                                                            to={il3.menuUrl}
                                                                            icon={il3.menuIcon}
                                                                        >
                                                                            {il3.menuNameTh}
                                                                        </Sidenav.RouterLink>
                                                                    ))}
                                                                </Sidenav.Menu>
                                                            )
                                                        } else {
                                                            result = (
                                                                <Sidenav.RouterLink
                                                                    key={subIndex}
                                                                    to={subMenu.menuUrl}
                                                                    icon={subMenu.menuIcon}
                                                                >
                                                                    {subMenu.menuNameTh}
                                                                </Sidenav.RouterLink>
                                                            )
                                                        }

                                                        return result
                                                    })}
                                                </>
                                            </Sidenav.Menu>
                                        ) : (
                                            <Sidenav.RouterLink
                                                key={index}
                                                to={item.menuUrl}
                                                icon={item.menuIcon}
                                            >
                                                {item.menuNameTh}
                                            </Sidenav.RouterLink>
                                        )}
                                    </React.Fragment>
                                ),
                            )}
                    </div>
                </Collapse>
                <Sidenav.Divider className="mb-1"/>
            </div>
        ))
    }

    render() {
        console.log('before render sidenav', this.state?.roleMenus)
        return (
            <Sidenav
                orientation={this.props.orientation}
                className={this.layoutSidenavClasses()}
            >
                {/* Brand demo (see src/demo.css) */}
                {this.props.orientation !== 'horizontal' && (
                    <React.Fragment>
                        <div className="app-brand demo">
              <span
                  className="app-brand-logo demo"
                  style={{backgroundColor: '#EEEEEE'}}
              >
                {/* <svg viewBox="0 0 148 80" xmlns="http://www.w3.org/2000/svg" xmlnsXlink="http://www.w3.org/1999/xlink"><defs><linearGradient id="a" x1="46.49" x2="62.46" y1="53.39" y2="48.2" gradientUnits="userSpaceOnUse"><stop stopOpacity=".25" offset="0"></stop><stop stopOpacity=".1" offset=".3"></stop><stop stopOpacity="0" offset=".9"></stop></linearGradient><linearGradient id="e" x1="76.9" x2="92.64" y1="26.38" y2="31.49" xlinkHref="#a"></linearGradient><linearGradient id="d" x1="107.12" x2="122.74" y1="53.41" y2="48.33" xlinkHref="#a"></linearGradient></defs><path style={{fill: '#fff'}} transform="translate(-.1)" d="M121.36,0,104.42,45.08,88.71,3.28A5.09,5.09,0,0,0,83.93,0H64.27A5.09,5.09,0,0,0,59.5,3.28L43.79,45.08,26.85,0H.1L29.43,76.74A5.09,5.09,0,0,0,34.19,80H53.39a5.09,5.09,0,0,0,4.77-3.26L74.1,35l16,41.74A5.09,5.09,0,0,0,94.82,80h18.95a5.09,5.09,0,0,0,4.76-3.24L148.1,0Z"></path><path transform="translate(-.1)" d="M52.19,22.73l-8.4,22.35L56.51,78.94a5,5,0,0,0,1.64-2.19l7.34-19.2Z" fill="url(#a)"></path><path transform="translate(-.1)" d="M95.73,22l-7-18.69a5,5,0,0,0-1.64-2.21L74.1,35l8.33,21.79Z" fill="url(#e)"></path><path transform="translate(-.1)" d="M112.73,23l-8.31,22.12,12.66,33.7a5,5,0,0,0,1.45-2l7.3-18.93Z" fill="url(#d)"></path></svg> */}
                  {/* <img src={`${process.env.PUBLIC_URL}/img/KU_Logo_PNG.png`} alt="Kasetsart University" style={{width :23,height:28}} className="profile-avatar rounded-circle" /> */}
                  {this.props.user && this.props.user?.userType === '1' && (
                      <img
                          src={`data:image/jpeg;base64,${this.state.stdImage}`}
                          alt="Kasetsart University"
                          style={{width: 40}}
                          className="profile-avatar rounded-circle"
                      />
                  )}
                  {this.props.user && this.props.user?.userType !== '1' && (
                      <img
                          src={`${process.env.PUBLIC_URL}/img/KU_Logo_PNG.png`}
                          alt="Kasetsart University"
                          style={{width: 23, height: 28, marginTop: 5}}
                          className="profile-avatar rounded-circle"
                      />
                  )}
              </span>
                            <Link
                                to={process.env.REACT_APP_LOGIN_ROUTE}
                                className="app-brand-text demo sidenav-text font-weight-normal ml-2"
                                style={{fontSize: 12, color: '#03A96B', fontWeight: 'bold'}}
                            >
                                {/* Kasetsart University */}
                                {this.props.user && this.props.user.firstNameTh + ' ' + this.props.user.lastNameTh}
                                {this.props.user?.userType === '1' && (
                                    <div
                                        className="small"
                                        style={{color: 'rgba(255, 255, 255, 0.75)', marginTop: '0.2rem'}}
                                    >
                                        {!_.isEmpty(this.props.user.student) ? this.props.user.student.studentTypeNameTh : null}
                                    </div>
                                )}
                            </Link>
                            <a
                                href="#toggle"
                                className="layout-sidenav-toggle sidenav-link text-large ml-auto"
                                onClick={this.toggleSidenav}
                            >
                                {/* <i className="ion ion-md-menu align-middle"></i> */}
                                <div style={{width: '1.5rem'}}>
                                    <BurgerIcon/>
                                </div>
                            </a>
                        </div>
                        <Sidenav.Divider className="mt-0"/>
                    </React.Fragment>
                )}

                {/* Links */}
                <div
                    className={`sidenav-inner ${this.props.orientation !== 'horizontal' ? 'py-1' : ''}`}
                    style={{paddingBottom: '5rem'}}
                >
                    {this.buildMenusWithSource()}

                    {/* {this.state?.roleMenus &&
            <>
              {this.buildMenus("FIN")}

              {this.buildMenus("GRD")}
            </>
          } */}

                    <Sidenav.Divider className="mb-1"/>
                    {/* <Sidenav.Header className="small font-weight-semibold">EXAMPLE Theme UI</Sidenav.Header> */}

                    {/* Dashboards */}
                    {/* <Sidenav.Menu icon="ion ion-md-speedometer" linkText="Dashboards" active={this.isMenuActive('/dashboards')} open={this.isMenuOpen('/dashboards')}>

            <Sidenav.RouterLink to="/dashboards/dashboard-1">Dashboard 1</Sidenav.RouterLink>
            <Sidenav.RouterLink to="/dashboards/dashboard-2">Dashboard 2</Sidenav.RouterLink>
            <Sidenav.RouterLink to="/dashboards/dashboard-3">Dashboard 3</Sidenav.RouterLink>
            <Sidenav.RouterLink to="/dashboards/dashboard-4">Dashboard 4</Sidenav.RouterLink>
            <Sidenav.RouterLink to="/dashboards/dashboard-5">Dashboard 5</Sidenav.RouterLink>
          </Sidenav.Menu> */}

                    {/* Layouts */}
                    {/* <Sidenav.Menu icon="ion ion-ios-albums" linkText="Layouts" active={this.isMenuActive('/layouts')} open={this.isMenuOpen('/layouts')}>
            <Sidenav.RouterLink to="/layouts/options">Layout options</Sidenav.RouterLink>
            <Sidenav.RouterLink to="/layouts/helpers">Layout helpers</Sidenav.RouterLink>
            <Sidenav.RouterLink to="/layouts/layout-1">Layout 1</Sidenav.RouterLink>
            <Sidenav.RouterLink to="/layouts/layout-1-flex">Layout 1 (Flex)</Sidenav.RouterLink>
            <Sidenav.RouterLink to="/layouts/layout-2">Layout 2</Sidenav.RouterLink>
            <Sidenav.RouterLink to="/layouts/layout-2-flex">Layout 2 (Flex)</Sidenav.RouterLink>
            <Sidenav.RouterLink to="/layouts/without-navbar">Without navbar</Sidenav.RouterLink>
            <Sidenav.RouterLink to="/layouts/without-navbar-flex">Without navbar (Flex)</Sidenav.RouterLink>
            <Sidenav.RouterLink to="/layouts/without-sidenav">Without sidenav</Sidenav.RouterLink>
            <Sidenav.RouterLink to="/layouts/horizontal-sidenav">Horizontal sidenav</Sidenav.RouterLink>
            <Sidenav.RouterLink to="/layouts/blank">Blank</Sidenav.RouterLink>
          </Sidenav.Menu>

          <Sidenav.Divider className="mb-1" />
          <Sidenav.Header className="small font-weight-semibold">ELEMENTS</Sidenav.Header>

          <Sidenav.RouterLink to="/typography" icon="ion ion-md-quote">Typography</Sidenav.RouterLink> */}

                    {/* Layouts */}
                    {/* <Sidenav.Menu icon="ion ion-md-cube" linkText="User inteface" active={this.isMenuActive('/ui')} open={this.isMenuOpen('/ui')}>
            <Sidenav.RouterLink to="/ui/buttons">Buttons</Sidenav.RouterLink>
            <Sidenav.RouterLink to="/ui/badges">Badges</Sidenav.RouterLink>
            <Sidenav.RouterLink to="/ui/dropdowns">Dropdowns</Sidenav.RouterLink>
            <Sidenav.RouterLink to="/ui/navs">Navs</Sidenav.RouterLink>
            <Sidenav.RouterLink to="/ui/pagination-and-breadcrumbs">Pagination and breadcrumbs</Sidenav.RouterLink>
            <Sidenav.RouterLink to="/ui/progress-bars">Progress bars</Sidenav.RouterLink>
            <Sidenav.RouterLink to="/ui/list-groups">List groups</Sidenav.RouterLink>
            <Sidenav.RouterLink to="/ui/notifications">Notifications</Sidenav.RouterLink>
            <Sidenav.RouterLink to="/ui/modals">Modals</Sidenav.RouterLink>
            <Sidenav.RouterLink to="/ui/tooltips-and-popovers">Tooltips and popovers</Sidenav.RouterLink>
            <Sidenav.RouterLink to="/ui/thumbnails">Thumbnails</Sidenav.RouterLink>
            <Sidenav.RouterLink to="/ui/cards">Cards</Sidenav.RouterLink>
            <Sidenav.RouterLink to="/ui/accordion">Accordion</Sidenav.RouterLink>
            <Sidenav.RouterLink to="/ui/app-brand">App brand</Sidenav.RouterLink>
            <Sidenav.RouterLink to="/ui/navbar">Navbar</Sidenav.RouterLink>
            <Sidenav.RouterLink to="/ui/sidenav">Sivenav</Sidenav.RouterLink>
            <Sidenav.RouterLink to="/ui/footer">Footer</Sidenav.RouterLink>
            <Sidenav.RouterLink to="/ui/carousel">Carousel</Sidenav.RouterLink>
            <Sidenav.RouterLink to="/ui/lightbox">Lightbox</Sidenav.RouterLink>
            <Sidenav.RouterLink to="/ui/drag-and-drop">Drag&amp;Drop</Sidenav.RouterLink>
            <Sidenav.RouterLink to="/ui/treeview">Treeview</Sidenav.RouterLink>
            <Sidenav.RouterLink to="/ui/react-avatar-editor">React Avatar Editor</Sidenav.RouterLink>
            <Sidenav.RouterLink to="/ui/react-big-calendar">React Big Calendar</Sidenav.RouterLink>
            <Sidenav.RouterLink to="/ui/spinners">Spinners</Sidenav.RouterLink>
          </Sidenav.Menu> */}

                    {/* Forms */}
                    {/* <Sidenav.Menu icon="ion ion-md-switch" linkText="Forms" active={this.isMenuActive('/forms')} open={this.isMenuOpen('/forms')}>
            <Sidenav.RouterLink to="/forms/layouts-and-elements">Layouts and elements</Sidenav.RouterLink>
            <Sidenav.RouterLink to="/forms/controls">Controls</Sidenav.RouterLink>
            <Sidenav.RouterLink to="/forms/custom-controls">Custom controls</Sidenav.RouterLink>
            <Sidenav.RouterLink to="/forms/input-groups">Input groups</Sidenav.RouterLink>
            <Sidenav.RouterLink to="/forms/switchers">Switchers</Sidenav.RouterLink>
            <Sidenav.RouterLink to="/forms/input-spinner">Input spinner</Sidenav.RouterLink>
            <Sidenav.RouterLink to="/forms/sliders">Sliders</Sidenav.RouterLink>
            <Sidenav.RouterLink to="/forms/selects-and-tags">Selects and tags</Sidenav.RouterLink>
            <Sidenav.RouterLink to="/forms/pickers">Pickers</Sidenav.RouterLink>
            <Sidenav.RouterLink to="/forms/editors">Editors</Sidenav.RouterLink>
            <Sidenav.RouterLink to="/forms/file-upload">File upload</Sidenav.RouterLink>
            <Sidenav.RouterLink to="/forms/react-stepzilla">React Stepzilla</Sidenav.RouterLink>
            <Sidenav.RouterLink to="/forms/react-bootstrap-typeahead">React Bootstrap Typeahead</Sidenav.RouterLink>
            <Sidenav.RouterLink to="/forms/extras">Extras</Sidenav.RouterLink>
          </Sidenav.Menu> */}

                    {/* Tables */}
                    {/* <Sidenav.Menu icon="ion ion-md-grid" linkText="Tables" active={this.isMenuActive('/tables')} open={this.isMenuOpen('/tables')}>
            <Sidenav.RouterLink to="/tables/bootstrap">Bootstrap</Sidenav.RouterLink>
            <Sidenav.RouterLink to="/tables/react-table">React Table</Sidenav.RouterLink>
            <Sidenav.RouterLink to="/tables/react-bootstrap-table-2">React Bootstrap Table 2</Sidenav.RouterLink>
          </Sidenav.Menu> */}

                    {/* Charts */}
                    {/* <Sidenav.Menu icon="ion ion-md-pie" linkText="Charts" active={this.isMenuActive('/charts')} open={this.isMenuOpen('/charts')}>
            <Sidenav.RouterLink to="/charts/google-map-react">Google Map React</Sidenav.RouterLink>
            <Sidenav.RouterLink to="/charts/react-chartjs-2">React Chartjs 2</Sidenav.RouterLink>
            <Sidenav.RouterLink to="/charts/recharts">Recharts</Sidenav.RouterLink>
            <Sidenav.RouterLink to="/charts/react-sparklines">React Sparklines</Sidenav.RouterLink>
          </Sidenav.Menu> */}

                    {/* Icons */}
                    {/* <Sidenav.Menu icon="ion ion-ios-heart" linkText="Icons" active={this.isMenuActive('/icons')} open={this.isMenuOpen('/icons')}>
            <Sidenav.RouterLink to="/icons/font-awesome-5">Font Awesome 5</Sidenav.RouterLink>
            <Sidenav.RouterLink to="/icons/ionicons">Ionicons</Sidenav.RouterLink>
            <Sidenav.RouterLink to="/icons/linearicons">Linearicons</Sidenav.RouterLink>
            <Sidenav.RouterLink to="/icons/open-iconic">Open Iconic</Sidenav.RouterLink>
            <Sidenav.RouterLink to="/icons/stroke-icons-7">Stroke Icons 7</Sidenav.RouterLink>
          </Sidenav.Menu> */}

                    {/* Miscellaneous */}
                    {/* <Sidenav.Menu icon="ion ion-ios-flask" linkText="Miscellaneous" active={this.isMenuActive('/miscellaneous')} open={this.isMenuOpen('/miscellaneous')}>
            <Sidenav.RouterLink to="/miscellaneous/brand-colors">Brand colors</Sidenav.RouterLink>
            <Sidenav.RouterLink to="/miscellaneous/react-masonry-component">React Masonry Component</Sidenav.RouterLink>
            <Sidenav.RouterLink to="/miscellaneous/spinkit">SpinKit</Sidenav.RouterLink>
            <Sidenav.RouterLink to="/miscellaneous/react-ladda">React Ladda</Sidenav.RouterLink>
            <Sidenav.RouterLink to="/miscellaneous/numeral">Numeral</Sidenav.RouterLink>
            <Sidenav.RouterLink to="/miscellaneous/react-idle-timer">React Idle Timer</Sidenav.RouterLink>
            <Sidenav.RouterLink to="/miscellaneous/react-perfect-scrollbar">React Perfect Scrollbar</Sidenav.RouterLink>
            <Sidenav.RouterLink to="/miscellaneous/react-clipboardjs">React Clipboardjs</Sidenav.RouterLink>
          </Sidenav.Menu>

          <Sidenav.Divider className="mb-1" />
          <Sidenav.Header className="small font-weight-semibold">EXTRAS</Sidenav.Header> */}

                    {/* Pages */}
                    {/* <Sidenav.Menu icon="ion ion-md-document" linkText="Pages" badgeText="59" badgeVariant="primary" active={this.isMenuActive('/pages')} open={this.isMenuOpen('/pages')}>
            <Sidenav.Menu linkText="Articles" active={this.isMenuActive('/pages/articles')} open={this.isMenuOpen('/pages/articles')}>
              <Sidenav.RouterLink to="/pages/articles/list">List</Sidenav.RouterLink>
              <Sidenav.RouterLink to="/pages/articles/edit">Edit</Sidenav.RouterLink>
            </Sidenav.Menu>
            <Sidenav.Menu linkText="Authentication" active={this.isMenuActive('/pages/authentication')} open={this.isMenuOpen('/pages/authentication')}>
              <Sidenav.RouterLink to="/pages/authentication/login-v1">Login v1</Sidenav.RouterLink>
              <Sidenav.RouterLink to="/pages/authentication/register-v1">Register v1</Sidenav.RouterLink>
              <Sidenav.RouterLink to="/pages/authentication/login-v2">Login v2</Sidenav.RouterLink>
              <Sidenav.RouterLink to="/pages/authentication/register-v2">Register v2</Sidenav.RouterLink>
              <Sidenav.RouterLink to="/pages/authentication/login-v3">Login v3</Sidenav.RouterLink>
              <Sidenav.RouterLink to="/pages/authentication/register-v3">Register v3</Sidenav.RouterLink>
              <Sidenav.RouterLink to="/pages/authentication/login-and-register">Login + register</Sidenav.RouterLink>
              <Sidenav.RouterLink to="/pages/authentication/lock-screen-v1">Lock screen v1</Sidenav.RouterLink>
              <Sidenav.RouterLink to="/pages/authentication/lock-screen-v2">Lock screen v2</Sidenav.RouterLink>
              <Sidenav.RouterLink to="/pages/authentication/password-reset">Password reset</Sidenav.RouterLink>
              <Sidenav.RouterLink to="/pages/authentication/email-confirm">Email confirm</Sidenav.RouterLink>
            </Sidenav.Menu>
            <Sidenav.Menu linkText="Education" active={this.isMenuActive('/pages/education')} open={this.isMenuOpen('/pages/education')}>
              <Sidenav.RouterLink to="/pages/education/courses-v1">Courses v1</Sidenav.RouterLink>
              <Sidenav.RouterLink to="/pages/education/courses-v2">Courses v2</Sidenav.RouterLink>
            </Sidenav.Menu>
            <Sidenav.Menu linkText="E-commerce" active={this.isMenuActive('/pages/e-commerce')} open={this.isMenuOpen('/pages/e-commerce')}>
              <Sidenav.RouterLink to="/pages/e-commerce/product-list">Product list</Sidenav.RouterLink>
              <Sidenav.RouterLink to="/pages/e-commerce/product-item">Product item</Sidenav.RouterLink>
              <Sidenav.RouterLink to="/pages/e-commerce/product-edit">Product edit</Sidenav.RouterLink>
              <Sidenav.RouterLink to="/pages/e-commerce/order-list">Order list</Sidenav.RouterLink>
              <Sidenav.RouterLink to="/pages/e-commerce/order-detail">Order detail</Sidenav.RouterLink>
            </Sidenav.Menu>
            <Sidenav.Menu linkText="Forums" active={this.isMenuActive('/pages/forums')} open={this.isMenuOpen('/pages/forums')}>
              <Sidenav.RouterLink to="/pages/forums/list">List</Sidenav.RouterLink>
              <Sidenav.RouterLink to="/pages/forums/threads">Threads</Sidenav.RouterLink>
              <Sidenav.RouterLink to="/pages/forums/discussion">Discussion</Sidenav.RouterLink>
            </Sidenav.Menu>
            <Sidenav.Menu linkText="Messages v1" active={this.isMenuActive('/pages/messages-v1')} open={this.isMenuOpen('/pages/messages-v1')}>
              <Sidenav.RouterLink to="/pages/messages-v1/list">List</Sidenav.RouterLink>
              <Sidenav.RouterLink to="/pages/messages-v1/item">Item</Sidenav.RouterLink>
              <Sidenav.RouterLink to="/pages/messages-v1/compose">Compose</Sidenav.RouterLink>
            </Sidenav.Menu>
            <Sidenav.Menu linkText="Messages v2" active={this.isMenuActive('/pages/messages-v2')} open={this.isMenuOpen('/pages/messages-v2')}>
              <Sidenav.RouterLink to="/pages/messages-v2/list">List</Sidenav.RouterLink>
              <Sidenav.RouterLink to="/pages/messages-v2/item">Item</Sidenav.RouterLink>
              <Sidenav.RouterLink to="/pages/messages-v2/compose">Compose</Sidenav.RouterLink>
            </Sidenav.Menu>
            <Sidenav.Menu linkText="Messages v3" active={this.isMenuActive('/pages/messages-v3')} open={this.isMenuOpen('/pages/messages-v3')}>
              <Sidenav.RouterLink to="/pages/messages-v3/list">List</Sidenav.RouterLink>
              <Sidenav.RouterLink to="/pages/messages-v3/item">Item</Sidenav.RouterLink>
              <Sidenav.RouterLink to="/pages/messages-v3/compose">Compose</Sidenav.RouterLink>
            </Sidenav.Menu>
            <Sidenav.Menu linkText="Projects" active={this.isMenuActive('/pages/projects')} open={this.isMenuOpen('/pages/projects')}>
              <Sidenav.RouterLink to="/pages/projects/list">List</Sidenav.RouterLink>
              <Sidenav.RouterLink to="/pages/projects/item">Item</Sidenav.RouterLink>
            </Sidenav.Menu>
            <Sidenav.Menu linkText="Tickets" active={this.isMenuActive('/pages/tickets')} open={this.isMenuOpen('/pages/tickets')}>
              <Sidenav.RouterLink to="/pages/tickets/list">List</Sidenav.RouterLink>
              <Sidenav.RouterLink to="/pages/tickets/edit">Edit</Sidenav.RouterLink>
            </Sidenav.Menu>
            <Sidenav.Menu linkText="Users" active={this.isMenuActive('/pages/users')} open={this.isMenuOpen('/pages/users')}>
              <Sidenav.RouterLink to="/pages/users/list">List</Sidenav.RouterLink>
              <Sidenav.RouterLink to="/pages/users/view">View</Sidenav.RouterLink>
              <Sidenav.RouterLink to="/pages/users/edit">Edit</Sidenav.RouterLink>
            </Sidenav.Menu>
            <Sidenav.RouterLink to="/pages/account-settings">Account settings</Sidenav.RouterLink>
            <Sidenav.RouterLink to="/pages/chat">Chat</Sidenav.RouterLink>
            <Sidenav.RouterLink to="/pages/clients">Clients</Sidenav.RouterLink>
            <Sidenav.RouterLink to="/pages/contacts">Contacts</Sidenav.RouterLink>
            <Sidenav.RouterLink to="/pages/faq">FAQ</Sidenav.RouterLink>
            <Sidenav.RouterLink to="/pages/file-manager">File manager</Sidenav.RouterLink>
            <Sidenav.RouterLink to="/pages/gallery">Gallery</Sidenav.RouterLink>
            <Sidenav.RouterLink to="/pages/help-center">Help center</Sidenav.RouterLink>
            <Sidenav.RouterLink to="/pages/invoice">Invoice</Sidenav.RouterLink>
            <Sidenav.RouterLink to="/pages/kanban-board">Kanban board</Sidenav.RouterLink>
            <Sidenav.RouterLink to="/pages/pricing">Pricing</Sidenav.RouterLink>
            <Sidenav.RouterLink to="/pages/profile-v1">Profile v1</Sidenav.RouterLink>
            <Sidenav.RouterLink to="/pages/profile-v2">Profile v2</Sidenav.RouterLink>
            <Sidenav.RouterLink to="/pages/search-results">Search results</Sidenav.RouterLink>
            <Sidenav.RouterLink to="/pages/task-list">Task list</Sidenav.RouterLink>
            <Sidenav.RouterLink to="/pages/teams">Teams</Sidenav.RouterLink>
            <Sidenav.RouterLink to="/pages/vacancies">Vacancies</Sidenav.RouterLink>
            <Sidenav.RouterLink to="/pages/voting">Voting</Sidenav.RouterLink>
          </Sidenav.Menu> */}

                    {/* Complete UI */}
                    {/* <Sidenav.Menu icon="ion ion-logo-buffer" linkText="Complete UI">
            <Sidenav.RouterLink to="/complete-ui/base">Base</Sidenav.RouterLink>
            <Sidenav.RouterLink to="/complete-ui/plugins">Plugins</Sidenav.RouterLink>
            <Sidenav.RouterLink to="/complete-ui/charts">Charts</Sidenav.RouterLink>
          </Sidenav.Menu> */}

                    {/* ONLY_DEMO */}
                    {/* <Sidenav.Menu icon="ion ion-ios-briefcase" linkText="UI Kit">
            <Sidenav.Link target="_blank" rel="noopener noreferrer" href="http://localhost:8080/uikit/base.html">Base</Sidenav.Link>
            <Sidenav.Link target="_blank" rel="noopener noreferrer" href="http://localhost:8080/uikit/company.html">Company</Sidenav.Link>
            <Sidenav.Link target="_blank" rel="noopener noreferrer" href="http://localhost:8080/uikit/dashboard.html">Dashboard</Sidenav.Link>
            <Sidenav.Link target="_blank" rel="noopener noreferrer" href="http://localhost:8080/uikit/e-commerce.html">E-Commerce</Sidenav.Link>
            <Sidenav.Link target="_blank" rel="noopener noreferrer" href="http://localhost:8080/uikit/headers-and-footers.html">Headers &amp; Footers</Sidenav.Link>
            <Sidenav.Link target="_blank" rel="noopener noreferrer" href="http://localhost:8080/uikit/magazine.html">Magazine</Sidenav.Link>
            <Sidenav.Link target="_blank" rel="noopener noreferrer" href="http://localhost:8080/uikit/social.html">Social</Sidenav.Link>
          </Sidenav.Menu> */}

                    {/* <Sidenav.Menu icon="ion ion-md-gift" linkText="Extra pages">
            <Sidenav.Menu linkText="Blog">
              <Sidenav.Link target="_blank" rel="noopener noreferrer" href="http://localhost:8080/extra-pages/blog.html">Index</Sidenav.Link>
              <Sidenav.Link target="_blank" rel="noopener noreferrer" href="http://localhost:8080/extra-pages/blog-article.html">Article</Sidenav.Link>
            </Sidenav.Menu>
            <Sidenav.Menu linkText="E-mail templates">
              <Sidenav.Link target="_blank" rel="noopener noreferrer" href="http://localhost:8080/extra-pages/email-confirmation.html">Confirmation</Sidenav.Link>
              <Sidenav.Link target="_blank" rel="noopener noreferrer" href="http://localhost:8080/extra-pages/email-invoice.html">Invoice</Sidenav.Link>
              <Sidenav.Link target="_blank" rel="noopener noreferrer" href="http://localhost:8080/extra-pages/email-password-reset.html">Password reset</Sidenav.Link>
            </Sidenav.Menu>
            <Sidenav.Menu linkText="Errors">
              <Sidenav.Link target="_blank" rel="noopener noreferrer" href="http://localhost:8080/extra-pages/404-1.html">404 v1</Sidenav.Link>
              <Sidenav.Link target="_blank" rel="noopener noreferrer" href="http://localhost:8080/extra-pages/500-1.html">500 v1</Sidenav.Link>
              <Sidenav.Link target="_blank" rel="noopener noreferrer" href="http://localhost:8080/extra-pages/404-2.html">404 v2</Sidenav.Link>
              <Sidenav.Link target="_blank" rel="noopener noreferrer" href="http://localhost:8080/extra-pages/500-2.html">500 v2</Sidenav.Link>
            </Sidenav.Menu>
            <Sidenav.Menu linkText="Landings">
              <Sidenav.Link target="_blank" rel="noopener noreferrer" href="http://localhost:8080/extra-pages/landing-1.html">Landing v1</Sidenav.Link>
              <Sidenav.Link target="_blank" rel="noopener noreferrer" href="http://localhost:8080/extra-pages/landing-2.html">Landing v2</Sidenav.Link>
              <Sidenav.Link target="_blank" rel="noopener noreferrer" href="http://localhost:8080/extra-pages/landing-3.html">Landing v3</Sidenav.Link>
              <Sidenav.Link target="_blank" rel="noopener noreferrer" href="http://localhost:8080/extra-pages/landing-4.html">Landing v4</Sidenav.Link>
            </Sidenav.Menu>
            <Sidenav.Menu linkText="Portfolio">
              <Sidenav.Link target="_blank" rel="noopener noreferrer" href="http://localhost:8080/extra-pages/portfolio.html">Index</Sidenav.Link>
              <Sidenav.Link target="_blank" rel="noopener noreferrer" href="http://localhost:8080/extra-pages/portfolio-item-1.html">Item v1</Sidenav.Link>
              <Sidenav.Link target="_blank" rel="noopener noreferrer" href="http://localhost:8080/extra-pages/portfolio-item-2.html">Item v2</Sidenav.Link>
              <Sidenav.Link target="_blank" rel="noopener noreferrer" href="http://localhost:8080/extra-pages/portfolio-blog.html">Blog</Sidenav.Link>
              <Sidenav.Link target="_blank" rel="noopener noreferrer" href="http://localhost:8080/extra-pages/portfolio-article.html">Article</Sidenav.Link>
            </Sidenav.Menu>
            <Sidenav.Menu linkText="Shop">
              <Sidenav.Link target="_blank" rel="noopener noreferrer" href="http://localhost:8080/extra-pages/shop.html">Index</Sidenav.Link>
              <Sidenav.Link target="_blank" rel="noopener noreferrer" href="http://localhost:8080/extra-pages/shop-product-grid.html">Product grid</Sidenav.Link>
              <Sidenav.Link target="_blank" rel="noopener noreferrer" href="http://localhost:8080/extra-pages/shop-product-list.html">Product list</Sidenav.Link>
              <Sidenav.Link target="_blank" rel="noopener noreferrer" href="http://localhost:8080/extra-pages/shop-product.html">Product page</Sidenav.Link>
              <Sidenav.Link target="_blank" rel="noopener noreferrer" href="http://localhost:8080/extra-pages/shop-cart.html">Shopping cart</Sidenav.Link>
              <Sidenav.Link target="_blank" rel="noopener noreferrer" href="http://localhost:8080/extra-pages/shop-checkout.html">Checkout</Sidenav.Link>
            </Sidenav.Menu>
            <Sidenav.Link target="_blank" rel="noopener noreferrer" href="http://localhost:8080/extra-pages/coming-soon.html">Coming soon</Sidenav.Link>
          </Sidenav.Menu> */}
                    {/* / ONLY_DEMO */}
                </div>
            </Sidenav>
        )
    }
}

LayoutSidenav.propTypes = {
    orientation: PropTypes.oneOf(['vertical', 'horizontal']),
}

LayoutSidenav.defaultProps = {
    orientation: 'vertical',
}

export default connect(
    store => ({
        sidenavBg: store.theme.sidenavBg,
        setting: store.theme,
        user: store.authen.user ? store.authen.user : undefined,
    }),
    {},
)(LayoutSidenav)
